import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GbgrundstueckService, GrundstueckId } from '../../core/gb-api';
import { TimepointService } from '../../core/services/timepoint.service';
import { AppConfigService } from '../../core/services/app-config.service';
import { AbstractHistoryInput } from '../../shared/components/abstract-component/abstract-history-input.component';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'cap-abstract-grundstueck-rubrik',
  templateUrl: './abstract-grundstueck-entry-from-input.component.html',
  styleUrls: ['./abstract-grundstueck-entry-from-input.component.scss']
})
export class AbstractGrundstueckEntryFromInputComponent extends AbstractHistoryInput {
  @Input()
  public gsId: GrundstueckId;

  protected grundstueckEntry;

  public constructor(
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService
  ) {
    super(appConfigService);
  }

  protected isLoadRelevantInputChange(changes: SimpleChanges) {
    return changes['gsId'] && changes.gsId['currentValue'] && changes.gsId.currentValue;
  }

  protected loadData() {
    const timepointCtx = this.timepointService.timepointCtx;
    this.addSub(
      this.grundstueckService
        .loadGrundstueckListEntryById(this.gsId.id, timepointCtx.timepointIso, timepointCtx.timepointId)
        .pipe(tap((g) => (this.grundstueckEntry = g)))
        .subscribe()
    );
  }
}
